export const REALM_NAME = 'merchants';

export const ERROR_CODE = {
  'invalid_grant': 'invalid_grant',
  'invalid_request': 'invalid_request',
  'unsupported_grant_type': 'unsupported_grant_type',
  'invalid_scope': 'invalid_scope',
  'unauthorized_client': 'unauthorized_client',
};
